import { Dispensary } from "@/custom-types/Dispensary";

const isDispensaryDualLicense = (tags: Dispensary["tags"]) =>
  tags?.includes("dualLicense");

export default isDispensaryDualLicense;
